var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 262.284,
    height: 57.135,
    viewBox: "0 0 262.284 57.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo3",
    transform: "translate(-467.017 -5067.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M491.443-26.333a20.756,20.756,0,0,1-8.65-1.642,12.167,12.167,0,0,1-5.446-4.565,12.259,12.259,0,0,1-1.841-6.687,12.818,12.818,0,0,1,1.841-6.845,12.385,12.385,0,0,1,5.607-4.726,22.071,22.071,0,0,1,9.209-1.721h12.092v-.96a5.316,5.316,0,0,0-2.081-4.327,8.551,8.551,0,0,0-5.527-1.68,11.351,11.351,0,0,0-3.8.562,7.253,7.253,0,0,0-2.443,1.361,6.463,6.463,0,0,0-1.442,1.922H477.267a12.957,12.957,0,0,1,2.724-6.607,15.992,15.992,0,0,1,6.485-4.8,25.376,25.376,0,0,1,10.09-1.8,24.6,24.6,0,0,1,10.251,2,16.211,16.211,0,0,1,6.845,5.566,13.9,13.9,0,0,1,2.443,8.048v26.027H505.857l-.962-3.682h-.48a13.662,13.662,0,0,1-5.124,3.2,21.233,21.233,0,0,1-7.848,1.361m2.722-9.209a13.646,13.646,0,0,0,5.326-.96,7.736,7.736,0,0,0,3.523-2.8,7.544,7.544,0,0,0,1.241-4.325v-.878H493.845a8.124,8.124,0,0,0-4.887,1.2,3.805,3.805,0,0,0-1.6,3.2,3.872,3.872,0,0,0,1.721,3.365,8.906,8.906,0,0,0,5.086,1.2",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M538.424-27.214q-5.847,0-8.849-2.844t-3-8.048V-57h-6.967V-67.975h6.967V-80.467h11.772v12.492h10.09V-57h-10.09v15.934a2.632,2.632,0,0,0,.679,2,3.147,3.147,0,0,0,2.2.641h7.208v11.211Z",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M574.278-26.333a23.3,23.3,0,0,1-11.372-2.8,21.212,21.212,0,0,1-8.088-7.647,20.38,20.38,0,0,1-2.962-10.851,20.173,20.173,0,0,1,2.962-10.81,21.334,21.334,0,0,1,8.088-7.608,23.651,23.651,0,0,1,11.532-2.8,23.271,23.271,0,0,1,11.17,2.683,20.011,20.011,0,0,1,7.848,7.407A20.126,20.126,0,0,1,596.3-48.2a21.4,21.4,0,0,1-.122,2.323,17.157,17.157,0,0,1-.278,1.841H563.388a10.49,10.49,0,0,0,2.081,4.2,10.3,10.3,0,0,0,3.8,2.923,11.733,11.733,0,0,0,4.925,1.042,12.049,12.049,0,0,0,5.323-1.042,10.544,10.544,0,0,0,3.324-2.4H595.1a20.693,20.693,0,0,1-3.8,6.005,20.534,20.534,0,0,1-6.927,4.966,23.8,23.8,0,0,1-10.09,2m10.412-25.143a8.37,8.37,0,0,0-1.723-3.965,9.975,9.975,0,0,0-3.682-2.883,11.2,11.2,0,0,0-4.846-1.082,12.034,12.034,0,0,0-5.124,1.042,11.208,11.208,0,0,0-3.8,2.844,10.514,10.514,0,0,0-2.2,4.044Z",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M334.017-27.414V-83.468h12.733v43.723H374.7v12.332Z",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M428.723-27.214V-67.975h10.251l.881,3.684h.4a13.819,13.819,0,0,1,4.925-3.2,18.5,18.5,0,0,1,7.246-1.363,18.528,18.528,0,0,1,9.01,2.2,15.553,15.553,0,0,1,6.324,6.406,20.6,20.6,0,0,1,2.283,9.97v23.063h-11.77v-21.38a9.5,9.5,0,0,0-1.162-4.767,8,8,0,0,0-3.122-3.123,9.243,9.243,0,0,0-4.527-1.08,9.757,9.757,0,0,0-4.563,1.08,7.519,7.519,0,0,0-3.2,3.123,9.763,9.763,0,0,0-1.121,4.767v21.38Z",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M406.655-37.439a22.048,22.048,0,0,1-22.047-22.047,21.975,21.975,0,0,1,1.74-8.6,23.1,23.1,0,0,0-9.236,18.5,23.139,23.139,0,0,0,23.137,23.139A23.144,23.144,0,0,0,422.817-44.5a21.993,21.993,0,0,1-16.162,7.056",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M411.2-69.909c.07.718.108,1.442.108,2.179a22.023,22.023,0,0,1-9.84,18.358,11.312,11.312,0,0,0,5.187,1.253,11.37,11.37,0,0,0,11.369-11.369A11.37,11.37,0,0,0,411.2-69.909",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M533.351-30.153v-.019h-.007l.007.019",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient3);
export default __webpack_public_path__ + "static/media/client3.e445176276bf0971366a957ea5ead53d.svg";
export { ForwardRef as ReactComponent };